import { FiPlus } from "react-icons/fi";
import { CardActionMenu } from "@/components/ui/CardActionMenu";
import { GoalRing } from "./GoalRing";

interface GoalFeatureCardProps {
  name: string;
  /** "$13,667 de $15,000 · faltan $1,333" */
  amountLine: string;
  percent: number;
  /** "91%" */
  percentLabel: string;
  /** "lograda" */
  percentCaption: string;
  /** "META PRINCIPAL" */
  kicker: string;
  /** "VENCE 15 DIC" */
  dueLabel?: string;
  /** "Aportar" */
  contributeLabel: string;
  /** Omit for a completed goal: there is nothing left to contribute. */
  onContribute?: () => void;
  menuLabel: string;
  editLabel: string;
  deleteLabel: string;
  onEdit: () => void;
  onDelete: () => void | Promise<void>;
}

/** Meta principal: tarjeta lilac con anillo grande, detalle en texto y botón de aporte. */
export const GoalFeatureCard = ({
  name,
  amountLine,
  percent,
  percentLabel,
  percentCaption,
  kicker,
  dueLabel,
  contributeLabel,
  onContribute,
  menuLabel,
  editLabel,
  deleteLabel,
  onEdit,
  onDelete,
}: GoalFeatureCardProps) => {
  return (
    <article className="relative rounded-[var(--ds-radius-lg)] bg-[var(--ds-card-lilac)] p-5 text-[var(--ds-on-card)] sm:p-6">
      <div className="absolute right-2 top-2 z-20">
        <CardActionMenu
          name={name}
          menuLabel={menuLabel}
          actions={[
            { kind: "edit", label: editLabel, onClick: onEdit },
            { kind: "delete", label: deleteLabel, onClick: onDelete },
          ]}
        />
      </div>

      <div className="flex items-center justify-between gap-3 pr-11 text-[11px] font-medium uppercase leading-[14px] tracking-[0.06em]">
        <span>{kicker}</span>
        {dueLabel && <span className="whitespace-nowrap">{dueLabel}</span>}
      </div>

      <div className="my-4 flex justify-center">
        <GoalRing
          percent={percent}
          size={220}
          stroke={22}
          color="var(--ds-on-card)"
          track="var(--ds-track-lilac)"
          label={`${name}: ${percentLabel}`}
        >
          <span className="font-[var(--ds-font-display)] text-[48px] leading-none tracking-[-0.04em]">{percentLabel}</span>
          <span className="text-sm leading-5">{percentCaption}</span>
        </GoalRing>
      </div>

      <h3 className="m-0 text-[18px] font-medium leading-6">{name}</h3>
      <p className="mb-4 mt-0.5 text-[15px] leading-[22px]">{amountLine}</p>

      {onContribute ? (
        <button
          type="button"
          onClick={onContribute}
          className="app-focus-ring inline-flex h-11 items-center gap-2 rounded-full border-[1.5px] border-[var(--ds-on-card)] bg-transparent px-5 text-[15px] font-medium text-[var(--ds-on-card)]"
        >
          <FiPlus aria-hidden="true" className="h-[18px] w-[18px]" />
          {contributeLabel}
        </button>
      ) : null}
    </article>
  );
};
